/* ============================================================================
   KAMSAH - REDESIGN V2 - TAGINES COLLECTION: SUPREME / CLASSIC GROUPING
   DRAFT theme "Test Kamsah Redesign V2" only.
   Loaded from snippets/include_script_js.liquid.

   WHAT THIS DOES
   The Tagines collection holds six products - three Supreme colours and three
   Classic colours. Shopify renders them as one flat grid, which tells the
   customer nothing about the two ranges or why one costs $10 more.

   This regroups that single grid into two labelled families, and puts a
   two-card chooser above them so both ranges are reachable without scrolling.

   WHY JAVASCRIPT AND NOT A TEMPLATE
   Splitting the grid properly would mean a custom collection template, and
   assigning a template to a collection is a STORE setting (templateSuffix),
   not a theme one - it would take effect on the live site the moment it was
   saved, with no way to stage it. This layer keeps the whole change inside
   the draft theme so it can be compared against live before anything ships.

   BEFORE THIS BECOMES PERMANENT: port it to a proper collection template so
   the grouping renders server-side rather than after paint.

   Guarded and idempotent. If the markup is not what it expects it does
   nothing and the ordinary grid is left alone.
   TO REVERT: remove the one <script> line in include_script_js.liquid.
   ========================================================================== */

(function () {
  'use strict';

  /* only the tagines collection - never any other collection page */
  if (!/^\/collections\/tagines\/?$/.test(window.location.pathname)) return;
  if (document.querySelector('.k-tg-fam')) return;           // already built

  var COLOURS = {
    blue:      { name: 'Bohemian Blue',           dot: 'radial-gradient(circle at 34% 28%,#5E90C4,#2E5C8A 60%,#1D3F63)' },
    red:       { name: 'Tuareg Red',              dot: 'radial-gradient(circle at 34% 28%,#D9705F,#B03A2E 60%,#7D231A)' },
    turquoise: { name: 'Mediterranean Turquoise', dot: 'radial-gradient(circle at 34% 28%,#6FC7C7,#3E9C9C 60%,#226C6C)' }
  };

  var FAMILIES = [
    {
      key: 'supreme', id: 'k-tg-supreme', label: 'Supreme',
      def: 'The pattern carries <b>across the base as well as the lid</b> — finished on every surface you see once it’s open at the table.',
      from: 'from $119.95',
      pot: '<svg viewBox="0 0 100 112" aria-hidden="true">' +
        '<defs><linearGradient id="kTgA" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#C4633A"/><stop offset="1" stop-color="#8A3915"/></linearGradient></defs>' +
        '<path d="M50 5 L79 63 H21 Z" fill="url(#kTgA)"/>' +
        '<path d="M50 19 L68 56 H32 Z" fill="none" stroke="#F7EFE2" stroke-width="3.6"/>' +
        '<circle cx="50" cy="36" r="3.6" fill="#F7EFE2"/>' +
        '<path d="M11 67 h78 a6 6 0 0 1 -6 8 H17 a6 6 0 0 1 -6 -8 Z" fill="url(#kTgA)"/>' +
        '<path d="M13 71 h74" stroke="#F7EFE2" stroke-width="3"/>' +
        '<path d="M21 81 h58 l-6 18 H27 Z" fill="url(#kTgA)"/>' +
        '<path d="M27 88 h46" stroke="#F7EFE2" stroke-width="3"/>' +
        '<circle cx="38" cy="94" r="2.3" fill="#F7EFE2"/><circle cx="50" cy="94" r="2.3" fill="#F7EFE2"/><circle cx="62" cy="94" r="2.3" fill="#F7EFE2"/>' +
        '</svg>',
      blurb: 'Painted lid <em>and</em> base · from $119.95'
    },
    {
      key: 'classic', id: 'k-tg-classic', label: 'Classic',
      def: 'A painted lid over <b>bare fired clay</b>, so you see the Nabeul earthenware the pot is actually made of.',
      from: 'from $109.95',
      pot: '<svg viewBox="0 0 100 112" aria-hidden="true">' +
        '<defs><linearGradient id="kTgB" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#C4633A"/><stop offset="1" stop-color="#8A3915"/></linearGradient>' +
        '<linearGradient id="kTgC" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#D89468"/><stop offset="1" stop-color="#B4714A"/></linearGradient></defs>' +
        '<path d="M50 5 L79 63 H21 Z" fill="url(#kTgB)"/>' +
        '<path d="M50 19 L68 56 H32 Z" fill="none" stroke="#F7EFE2" stroke-width="3.6"/>' +
        '<circle cx="50" cy="36" r="3.6" fill="#F7EFE2"/>' +
        '<path d="M11 67 h78 a6 6 0 0 1 -6 8 H17 a6 6 0 0 1 -6 -8 Z" fill="url(#kTgC)"/>' +
        '<path d="M21 81 h58 l-6 18 H27 Z" fill="url(#kTgC)"/>' +
        '</svg>',
      blurb: 'Painted lid, natural clay base · from $109.95'
    }
  ];

  function build() {
    var grid = document.querySelector('.product_listing__main');
    if (!grid || document.querySelector('.k-tg-fam')) return;

    var wraps = [].slice.call(grid.children).filter(function (el) {
      return el.className && el.className.indexOf('product_item_wrap') !== -1;
    });
    if (wraps.length < 2) return;   // nothing to group - leave the page alone

    /* sort each card into a family by its product URL, which is unambiguous.
       Titles get truncated in the card markup, so they are not safe to read. */
    var bucket = { supreme: [], classic: [], other: [] };
    wraps.forEach(function (w) {
      var a = w.querySelector('a[href*="/products/"]');
      var href = (a && a.getAttribute('href')) || '';
      var fam = href.indexOf('-supreme-') !== -1 ? 'supreme'
              : href.indexOf('-classic-') !== -1 ? 'classic' : 'other';
      bucket[fam].push({ el: w, href: href });
    });
    /* if the split did not actually work, do nothing rather than show a
       half-grouped page */
    if (!bucket.supreme.length || !bucket.classic.length) return;

    /* decorate each card with its colour chip and range tag */
    function decorate(entry, famLabel) {
      var shot = entry.el.querySelector('.product_item');
      if (!shot || shot.querySelector('.k-tg-dot')) return;
      var key = ['blue', 'red', 'turquoise'].filter(function (c) {
        return entry.href.indexOf(c) !== -1;
      })[0];
      shot.style.position = shot.style.position || 'relative';
      if (key && COLOURS[key]) {
        var dot = document.createElement('span');
        dot.className = 'k-tg-dot';
        dot.style.background = COLOURS[key].dot;
        dot.setAttribute('title', COLOURS[key].name);
        shot.appendChild(dot);
      }
      var tag = document.createElement('span');
      tag.className = 'k-tg-tag';
      tag.textContent = famLabel;
      shot.appendChild(tag);
    }

    var frag = document.createDocumentFragment();

    /* the chooser: both ranges one tap from the top */
    var chooser = document.createElement('div');
    chooser.className = 'k-tg-chooser';
    FAMILIES.forEach(function (f, i) {
      var a = document.createElement('a');
      a.className = 'k-tg-ch';
      a.href = '#' + f.id;
      a.innerHTML =
        '<span class="k-tg-num">0' + (i + 1) + '</span>' +
        '<span class="k-tg-pot">' + f.pot + '</span>' +
        '<span class="k-tg-cht"><span class="k-tg-t">' + f.label + '</span>' +
        '<span class="k-tg-d">' + f.blurb + '</span></span>' +
        '<span class="k-tg-arw"></span>';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById(f.id);
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      chooser.appendChild(a);
    });
    frag.appendChild(chooser);

    FAMILIES.forEach(function (f) {
      var items = bucket[f.key];
      if (!items.length) return;

      var sec = document.createElement('section');
      sec.className = 'k-tg-fam';
      sec.id = f.id;

      var head = document.createElement('div');
      head.className = 'k-tg-row';
      head.innerHTML =
        '<h2>' + f.label + '</h2>' +
        '<p class="k-tg-def">' + f.def + '</p>' +
        '<span class="k-tg-meta">' + items.length + ' colours · ' + f.from + '</span>';
      sec.appendChild(head);

      var g = document.createElement('div');
      g.className = 'row product_listing__main k-tg-grid';
      items.forEach(function (entry) {
        decorate(entry, f.label);
        g.appendChild(entry.el);          // moves the real card, markup intact
      });
      sec.appendChild(g);
      frag.appendChild(sec);
    });

    /* anything unclassified keeps its place in the original grid below */
    grid.parentNode.insertBefore(frag, grid);
    if (!bucket.other.length) grid.classList.add('k-tg-empty');
    document.body.classList.add('k-tg-on');
  }

  function run() { try { build(); } catch (e) { /* leave the stock grid */ } }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  /* the theme re-renders the grid after filtering/sorting */
  window.addEventListener('load', function () { setTimeout(run, 500); });
})();
